<template>
  <div class="loader__container">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>
